// extracted by mini-css-extract-plugin
export default {"TeamsList":"TeamsList_TeamsList__-zF3d"};